//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dataLoggerComparisonQuery from '~/apollo/queries/product/data-logger-comparison'

export default {
  apollo: {
    dataLoggerComparison: {
      prefetch: true,
      query: dataLoggerComparisonQuery
    }
  }
}
